<template>
    <div
        class="timeline"
        ref="timeline"
        v-show="mapLayersWithGroups && mapLayersWithGroups.length > 0">
        <div
            class="timeline-container" 
            v-for="group in mapLayersWithGroups"
            :key="'timeline' + group.blockID"
            >
                <md-button class="md-icon-button md-raised timeline-button" 
                @click="playTimeline(group)"
                :disabled="playing && group.interval === null"
                >
                    <md-icon v-if="playing">pause</md-icon>
                    <md-icon v-else>play_arrow</md-icon>
                </md-button>
                <vue-slider
                    :key="group.blockID"
                    :adsorb="true"
                    v-model="group.selectedLayer"
                    :min=0
                    :max="group.layers.length-1"
                    :marks="group.labels"
                    :tooltip="playing ? 'always' : 'active'"
                    :tooltip-formatter="val => group.tooltips[val]"
                    :tooltip-placement="'bottom'"
                    :interval=1
                    :dotOptions="dotOptions"
                    class="timeline-range"
                    ref="timeline"
                    />
        </div>
    </div>
</template>
<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 * 
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 * 
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';

export default {
    name: "GoogleMapTimeline",
    components: {
        VueSlider
    },
    data: () => ({
        playing: false,
        dotOptions: {},
    }),
    props: {
        google: {
            type: Object,
            required: true
        },
        map: {
            type: Object,
            required: true
        },
        mapLayers: {
            type: Array,
            required: true
        },
    },
    methods: {
        playTimeline(group) {
            if(this.playing){
                clearInterval(group.interval);
                group.interval=null;
                this.playing = false;
            } else {
                this.playing = true;
                       
                if(group.selectedLayer === group.layers.length - 1){
                    group.selectedLayer = 0
                }       
                       
                let self = this;                
                group.interval = setInterval(function(){
                    if(group.selectedLayer < group.layers.length - 1) {
                        group.selectedLayer++;
                    } else {
                        self.playing = false;
                        clearInterval(group.interval)
                        group.interval=null;
                    }
                }, 1000);   
            }
        }
    },
    computed: {
        mapLayersWithGroups() {// checks for more than one layer in a single block, this should be a property in data structure down the line
            let timelineGroups = this.mapLayers.filter(mapLayer => {
                return mapLayer.isGroup;
            });
            timelineGroups.forEach(group => {
                group.labels = {};
                group.tooltips = {};
                group.interval = null;
                let len = group.layers.length;
                group.layers.forEach((layer, index) => {
                    if(index === 0 || index === len - 1) {
                        group.labels[index] = layer.label;
                    } else {
                        group.labels[index] = "";
                    }
                    group.tooltips[index] = layer.label;
                })
            });
            return timelineGroups;
        }
    },
    watch: { // ensures when timeline is first loaded, first layer is displayed
        mapLayersWithGroups(groups){
            groups.forEach(group => {
                group.layers[0].displayLayer = true;
            })
        }
    },
    mounted() {
        const timeline = this.$refs.timeline;
        this.map.controls[this.google.maps.ControlPosition.BOTTOM_CENTER].push(
            timeline
        );
    }
}
</script>

<style lang="scss" scoped>
.timeline {
    width: 60%;
    padding-bottom: 50px;
    padding-left: 35px;
    padding-right: 40px;
    padding-top: 40px;
    display: flex;
    flex-direction: column;
}
.timeline-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;
}
.timeline-range {
    min-width: 90%;
    margin-left: 5px;
}
.timeline-button {
    min-width: 25px;
    max-width: 25px;
    min-height: 25px;
    max-height: 25px;
}
</style>

